export const context = {
  zIndex: 2000,
  lockCount: 0,
  stack: [],
  top() {
    return this.stack[this.stack.length - 1];
  }
};
